import { useEffect } from "react";

export const useMonthSyncEffect = ({
  scrollableAreaRef,
  months,
  visibleMonthIndex,
  setVisibleMonthIndex,
  getFirstVisibleDayIndex,
}: {
  scrollableAreaRef: React.RefObject<HTMLDivElement>;
  months: { startIndex: number; days: number }[];
  visibleMonthIndex: number;
  setVisibleMonthIndex: (index: number) => void;
  getFirstVisibleDayIndex: () => number;
}) => {
  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const firstVisibleIndex = getFirstVisibleDayIndex();
          const index = months.findIndex(
            (m) =>
              firstVisibleIndex >= m.startIndex &&
              firstVisibleIndex < m.startIndex + m.days,
          );
          if (index !== -1 && index !== visibleMonthIndex) {
            setVisibleMonthIndex(index);
          }
          ticking = false;
        });

        ticking = true;
      }
    };

    const container = scrollableAreaRef.current;
    container?.addEventListener("scroll", handleScroll);

    return () => {
      container?.removeEventListener("scroll", handleScroll);
    };
  }, [months, visibleMonthIndex]);
};